import React, { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import {
  Alert,
  Button,
  Skeleton,
  Stack,
  Card,
  Typography,
  Chip,
  Divider,
  IconButton,
  Icon,
  Box,
  Tooltip
} from 'investira.react.components';
import { displays } from 'investira.react.lib';
import { formats } from 'investira.sdk';
import { CorrelacaoMatriz, CorrelacaoHeatMap } from '../../../components/organisms';
import { PessoaImage } from '../../../components/molecules';
import services from '../../../services';
import utils from '../../../utils';

const ComparadorVisaoGeral = memo(({ ativos = [] }) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      gap={1}
      data-comparador-header-scroll="horizontal"
      sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
      {ativos.map((xFundo, xIdx) => {
        return (
          <Card
            sx={{
              flex: { xs: '0 0 240px', md: 1 },
              display: 'flex',
              flexDirection: 'column',
              p: 2
            }}>
            <Stack flexGrow={1} justifyContent="space-between">
              <Stack gap={1} mb={2}>
                <Stack direction="row" gap={1} justifyContent="space-between" alignItems="flex-end">
                  <PessoaImage
                    logoPessoaId={xFundo.logo_pessoa_id}
                    alt={xFundo.pessoa_fantasia}
                    hasLogo={xFundo.logo_ok}
                    size={36}
                  />
                  <Stack direction="row" gap={1}>
                    {xFundo?.benchmarkIndicadorId && (
                      <Chip
                        variant="outlined"
                        label={xFundo?.benchmarkIndicadorId}
                        size="small"
                        color="primary"
                      />
                    )}
                    {xFundo?.ativo_tipo && (
                      <Chip
                        variant="outlined"
                        label={xFundo?.ativo_tipo}
                        size="small"
                        color="primary"
                      />
                    )}
                  </Stack>
                </Stack>
                <Stack>
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="textPrimary"
                    sx={{ fontWeight: 600 }}>
                    {utils.helpers.getAtivoDescricao(xFundo)}
                  </Typography>
                  {xFundo?.emissor?.pessoa_fantasia && (
                    <Typography variant="caption" color="textSecondary">
                      {xFundo.emissor.pessoa_fantasia}
                    </Typography>
                  )}
                </Stack>
              </Stack>

              <Stack gap={1}>
                <Divider />
                <Stack direction="row" gap={1} justifyContent="space-between" alignItems="center">
                  <Stack direction="row" alignItems="center" gap={1}>
                    {xFundo?.isin && (
                      <Typography variant="caption" color="textPrimary">
                        {xFundo.isin}
                      </Typography>
                    )}

                    {xFundo?.emissor_cnpj && (
                      <>
                        <Divider flexItem orientation="vertical" />
                        <Typography variant="caption" color="textPrimary">
                          {displays.cnpj(xFundo.emissor_cnpj)}
                        </Typography>
                      </>
                    )}

                    {xFundo?.fundo?.situacao &&
                      xFundo.fundo.situacao !== 'Em Funcionamento Normal' && (
                        <>
                          <Divider flexItem orientation="vertical" />
                          <Typography variant="caption" color="textPrimary">
                            {xFundo.fundo.situacao}
                          </Typography>
                        </>
                      )}
                  </Stack>
                  <Stack>
                    <Tooltip title="Abrir detalhes do fundo em uma nova aba">
                      <Box
                        component={Link}
                        to={`/ativos/fundos/${xFundo.ifeed_ativo_id}`}
                        rel="search"
                        onClick={pEvent => pEvent.stopPropagation()}
                        target="_blank">
                        <Icon iconName="tab_link" size={24} color="primary" />
                      </Box>
                    </Tooltip>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        );
      })}
    </Stack>
  );
});

export default ComparadorVisaoGeral;
